module.exports = "<div><nv-react-component component=\"MyTakeAwayPage\"></nv-react-component></div>";